import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { btnCva, btnIconCva } from "../../../ui/button"
import { LearningPathCard } from "../../cards/learning-path-card"
import { homePageData } from "../../../constants/home"
import { events } from "../../../constants/analytics"
import PathIcon from "../../icons/path-icon"
import cn from "../../../utils/classname"
import IconRenderer from "../../../ui/icon/icon-renderer"
import { capture } from "../../../services/posthog"

const data = {
  title: "For all learning paths",
  subTitle:
    "Whether you’re a full-stack developer, designer, or looking to get into AI, we’ve got a path for you.",
}

const LearningPath = ({ covers }) => {
  const { learningPaths } = useStaticQuery(graphql`
    {
      learningPaths: allSpLearningPath(limit: 6) {
        nodes {
          id
          title
          slug
          steps
          difficulty
        }
      }
    }
  `)

  return (
    <div className="mt-[100px] sm:mt-[120px] container-lg flex flex-col">
      <div className="flex flex-col gap-1 ">
        <div className="text-neutral-12 text-jar-6 font-semibold">
          {data.title}
        </div>
        <p className="text-jar-4 text-neutral-11">{data.subTitle}</p>
      </div>
      <div className="w-[calc(100%+32px)] -mx-4 lg:mx-0 lg:w-full overflow-hidden mt-8 sm:mt-10">
        <div
          className={cn(
            "px-4 lg:px-0 flex gap-6 overflow-auto lg:grid lg:grid-cols-3 items-stretch snap-x snap-mandatory",
            "pb-5 lg:pb-0"
          )}
        >
          {learningPaths.nodes.map(({ title, slug, steps, difficulty }) => (
            <LearningPathCard
              key={slug}
              cover={covers[slug]}
              steps={steps}
              title={title}
              slug={slug}
            />
          ))}
        </div>
      </div>

      <div className="w-[calc(100%+32px)] -mx-4 lg:mx-0 lg:w-full mt-3 sm:mt-5 lg:mt-10">
        <div className="flex flex-col sm:flex-row gap-4 sm:items-center bg-neutral-2 py-8 px-4 lg:px-8 lg:rounded-2xl">
          <PathIcon />
          <div className="flex flex-col flex-grow">
            <div className="text-jar-6 font-semibold text-neutral-12">
              We’ve got a path ready for you!
            </div>
            <p className="text-jar-4 text-neutral-11 mt-1">
              Discover our library filled with learning paths for all kinds of
              learners.
            </p>
          </div>
          <a
            id="home-browse-premium-library"
            href={homePageData.links.browseLibrary}
            className={cn(
              btnCva({ variant: "solid", theme: "neutral", size: 3 }),
              "shrink-0 w-full sm:w-fit"
            )}
            onClick={() => {
              capture(events.clicked_browse_library)
            }}
          >
            <span>Browse Library</span>
            <IconRenderer
              className={btnIconCva({ size: 3 })}
              iconType={"other"}
              iconName={"ChevronRightSmall"}
            />
          </a>
        </div>
      </div>
    </div>
  )
}

export default LearningPath
